import React from 'react';
import { useDispatch } from 'react-redux';

import classNames from 'classnames';

import { useIsAuthenticated } from '@azure/msal-react';

import { openOTPopUp } from 'features/order-tracker/store/actions';
import { useLivePersonPageChange } from 'features/order-tracker/store/hooks/useLivePersonPageChange';
import { toggleMainWindowScroll } from 'features/order-tracker/utils';

import { ERROR_TEXT, ERROR_TYPE, ErrorTypeValue } from './constants';

import styles from './styles.module.scss';

interface GeneralErrorComponentProps {
  errorType?: ErrorTypeValue;
}

export function GeneralErrorComponent({ errorType }: GeneralErrorComponentProps): React.ReactElement | null {
  const dispatch = useDispatch();
  const errorTypeClassNames: Record<string, (element: string) => string> = {
    [ERROR_TYPE.pageNotFound]: (element: string) => styles[`pageNotFound${element}`],
    [ERROR_TYPE.orderNotFound]: (element: string) => styles[`orderNotFound${element}`],
  };
  const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN;
  const isAuthenticated = useIsAuthenticated();

  if (!errorType) return null;

  const textWithArrow = (
    <>
      <svg width="8px" height="15px" viewBox="0 0 32 32">
        <path d="M25 0 L15 0 L0 20 L15 40 L25 40 L10 20 Z" />
      </svg>
      <span className={styles.errorIconText}>{ERROR_TEXT[errorType].linkText}</span>
    </>
  );

  const onTrackOrderButtonClick = (): void => {
    dispatch(openOTPopUp());
    useLivePersonPageChange();
    toggleMainWindowScroll();
  };

  return (
    <div className={errorTypeClassNames[errorType]('Container')}>
      <div className={classNames(styles.errorMessage, errorTypeClassNames[errorType]('Align'))}>
        <h1 className={styles.title}>{ERROR_TEXT[errorType].title}</h1>
        <h3 className={classNames(styles.title, errorTypeClassNames[errorType]('SubTitle'))}>
          {ERROR_TEXT[errorType].subTitle}
        </h3>
        {ERROR_TEXT[errorType].link &&
          (isAuthenticated ? (
            <a
              href={`${REACT_APP_MY_ACCOUNT_DOMAIN}/Account/LoginRedirect.aspx?tabId=12`}
              data-analytics-link={ERROR_TEXT[errorType].linkText}
              className={styles.errorIcon}
            >
              {textWithArrow}
            </a>
          ) : (
            <button
              className={styles.trackAnotherOrderButton}
              data-analytics-link={ERROR_TEXT[errorType].linkText}
              onClick={onTrackOrderButtonClick}
              type="button"
            >
              {textWithArrow}
            </button>
          ))}
      </div>
    </div>
  );
}
